// src/queries/seatingPlan.query.jsx
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getRequest, postRequest, putRequest, deleteRequest } from 'utils/http'

const SEATING_PLAN_QUERY_KEY = 'seating-plans'

export const getSeatingPlans = async (current = 1, pageSize = 20, venueId = null, search = '') => {
  return getRequest('seating-plans', {
    params: {
      page: current,
      pageSize,
      venue_id: venueId,
      searchQuery: search,
    },
  })
}

export const useGetSeatingPlans = (current = 1, pageSize = 20, venueId = null, search = '') => {
  return useQuery({
    queryKey: [SEATING_PLAN_QUERY_KEY, current, pageSize, venueId, search],
    queryFn: () => getSeatingPlans(current, pageSize, venueId, search),
  })
}

export const getSeatingPlan = async (id) => {
  return getRequest(`seating-plans/${id}`)
}

export const useGetSeatingPlan = (id) => {
  return useQuery({
    queryKey: [SEATING_PLAN_QUERY_KEY, id],
    queryFn: () => getSeatingPlan(id),
    enabled: !!id,
  })
}

export const createSeatingPlan = async (data) => {
  return postRequest('seating-plans', data)
}

export const useCreateSeatingPlan = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createSeatingPlan,
    onSuccess: () => {
      queryClient.invalidateQueries([SEATING_PLAN_QUERY_KEY])
    },
  })
}

export const updateSeatingPlan = async ({ id, data }) => {
  return putRequest(`seating-plans/${id}`, data)
}

export const useUpdateSeatingPlan = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateSeatingPlan,
    onSuccess: () => {
      queryClient.invalidateQueries([SEATING_PLAN_QUERY_KEY])
    },
  })
}

export const duplicateSeatingPlan = async (id) => {
  return postRequest(`seating-plans/${id}/duplicate`)
}

export const useDuplicateSeatingPlan = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: duplicateSeatingPlan,
    onSuccess: () => {
      queryClient.invalidateQueries([SEATING_PLAN_QUERY_KEY])
    },
  })
}

export const deleteSeatingPlan = async (id) => {
  return deleteRequest(`seating-plans/${id}`)
}

export const useDeleteSeatingPlan = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteSeatingPlan,
    onSuccess: () => {
      queryClient.invalidateQueries([SEATING_PLAN_QUERY_KEY])
    },
  })
}
